const normalizeBackendOrigin = (value) => {
  if (typeof value !== 'string') {
    return null;
  }
  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }
  return trimmed.replace(/\/+$/, '');
};

const getDefaultDevBackendOrigin = () => {
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }
  if (typeof window === 'undefined') {
    return null;
  }

  const { hostname, port } = window.location;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
  if (!isLocalhost || port !== '3000') {
    return null;
  }

  // CRA dev server usually runs on :3000 while the local Express API runs on :3001.
  return 'http://127.0.0.1:3001';
};

export const getBackendOrigin = () => (
  normalizeBackendOrigin(process.env.REACT_APP_BACKEND_URL)
  || getDefaultDevBackendOrigin()
);

export const getBackendApiBaseUrl = () => {
  const backendOrigin = getBackendOrigin();
  return backendOrigin ? `${backendOrigin}/api` : '/api';
};

export const getBackendEndpoint = (path) => {
  const rawPath = typeof path === 'string' ? path.trim() : '';
  const apiBaseUrl = getBackendApiBaseUrl();

  if (!rawPath || rawPath === '/') {
    return apiBaseUrl;
  }

  const normalizedPath = rawPath.startsWith('/') ? rawPath : `/${rawPath}`;

  if (normalizedPath === '/api') {
    return apiBaseUrl;
  }

  if (normalizedPath.startsWith('/api/')) {
    const backendOrigin = getBackendOrigin();
    return backendOrigin ? `${backendOrigin}${normalizedPath}` : normalizedPath;
  }

  return `${apiBaseUrl}${normalizedPath}`;
};
